import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'

export const ProfileImage = ({
  externalId,
  name,
}: {
  externalId: string
  name?: string
}) => (
  <CloudflareImage
    alt={name ?? 'Sponsor'}
    className='relative top-1/2 max-h-full w-full -translate-y-1/2 transform object-contain'
    fit='contain'
    height={200}
    imageId={externalId}
    width={200}
  />
)

export const BlankPiImage = () => (
  <div className='hidden size-[128px] items-center justify-center rounded-lg bg-neutral100 md:flex'>
    <Icon className='text-neutral500' icon={faUser} size='5x' />
  </div>
)
